/* eslint-disable complexity */
/* eslint-disable max-lines */
/* eslint-disable indent */
/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
// Libraries
import {
    getDependentSectionName,
    capitaliseString,
    capitalizeStringWithUnderscores,
    getFormButtonText,
} from '../../utils/helperMethods';
import { FormElems, CustomSelect, Alert, AlertModal } from '../../components/';
import {
    showLoader,
    hideLoader,
} from '../../redux/common/loader/loader.actions';
import {
    saveAndContinueRequest,
    resetSaveDataSuccessKey,
    submitStepFormRequest,
} from '../../containers/MerchantOnboard/redux/merchantOnBoard.actions';
import {
    updateSectionDataRequest,
    addMerchantStepUpdateMakerRequest,
    resetUpdateDataSuccessKey,
    getMerchantSectionInfoRequest,
    fetchBasicFormData,
    getMerchantInfoRequest,
} from '../../containers/MerchantOnboard/redux/editMerchant/editMerchant.actions';
import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';
import validate from './validator';
import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change as changeValue } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';
import { components } from 'react-select';
import { toast } from 'react-toastify';
import { isEmpty, last, first } from 'lodash';
import { useDispatch } from 'react-redux';
import { validators } from '../../utils/validators';
// Component

// Actions

// Constant

// Validator

// Styles
import './payModeTab.scss';
import { MAKER_CHECKER_EVENT_TYPES } from 'utils/constants/commonValues';
import RenderFieldList from './RenderFieldList';
import { TURN_OVER_CATEGORIES } from 'components/TerminalTab/constants';

const { REQUIRE } = validators;
const allOption = [{ value: 'all', label: 'ALL BANKS', checked: false }];
const allOptionWallets = [
    { value: 'all', label: 'ALL WALLETS', checked: false },
];

const customOptions = (bankList, draftData, optionFor) => {
    const formattedBanks =
        bankList &&
        bankList.length &&
        bankList
            .filter(elm => elm.subModeNameUI)
            .map(bank => ({
                label: bank.subModeNameUI,
                value: bank.subModeNameUI,
                data: {
                    paymentType: bank.paymentType,
                    paymentModeInfo: bank.subMode,
                    paymentModeInfoUI: bank.subModeNameUI,
                },
                checked: false,
            }));
    if (
        draftData &&
        draftData.data &&
        draftData.data.paymentModeDetails &&
        formattedBanks
    ) {
        const payDetails = draftData.data.paymentModeDetails;
        const netBanking = [];
        const wallets = [];
        payDetails.forEach(item => {
            if (!item) {
                return;
            }
            if (item.paymentType === 'NB') {
                netBanking.push(item.paymentModeInfo);
            }
            if (item.paymentType === 'WALLET') {
                wallets.push(item.paymentModeInfo);
            }
        });
        if (optionFor === 'NB') {
            return formattedBanks.map(item => {
                if (netBanking.includes(item.data.paymentModeInfo)) {
                    return {
                        ...item,
                        checked: true,
                    };
                }
                return item;
            });
        } else if (optionFor === 'WALLET') {
            return formattedBanks.map(item => {
                if (wallets.includes(item.data.paymentModeInfo)) {
                    return {
                        ...item,
                        checked: true,
                    };
                }
                return item;
            });
        }
    }
    return formattedBanks;
};

const ValueContainer = ({ children, ...props }) => {
    const { getValue, hasValue } = props;
    const newChildren = [...children];
    const nbValues = getValue().filter(item => item.value !== 'all').length;
    newChildren[0] = `${nbValues} Selected`;

    if (!hasValue) {
        return (
            <components.ValueContainer {...props}>
                {children}
            </components.ValueContainer>
        );
    }
    return (
        <components.ValueContainer {...props}>
            {newChildren}
        </components.ValueContainer>
    );
};

const Option = props => {
    const { data, isSelected } = props;
    data.checked = isSelected;
    const dataOptions = [data];
    return (
        <components.Option {...props}>
            <div className={data.value}>
                <FormElems.Checkbox
                    name={data.value}
                    options={dataOptions || []}
                    valueField="value"
                    labelField="label"
                />
            </div>
        </components.Option>
    );
};

const formatGroupLabel = data => (
    <div className={`group-label ${data.label ? data.label : 'empty'}`}>
        <label>{data.label}</label>
    </div>
);

const getPayOptions = (payData, staticData) => {
    if (payData && staticData) {
        const { CARD_TYPE, BANK_CODE } = staticData;
        const {
            creditCards,
            debitCards,
            netbanking,
            upi,
            debitCardBusinessSource,
            creditCardBusinessSource,
            emiBusinessSource,
            upiBusinessSource,
            upiAccountType,
            wallets,
            accountVerification,
            emi
        } = payData;
       
        const formatValues = {
            creditCards: [],
            debitCards: [],
            netbanking: [],
            upi: [],
            debitCardBusinessSources: [],
            creditCardBusinessSources: [],
            upiBusinessSources: [],
            upiAccountTypes: [],
            wallets: [],
            accountVerification: [],
            emi: [],
            emiBusinessSource: [],
        };

        if (debitCardBusinessSource && !isEmpty(debitCardBusinessSource)) {
            formatValues.debitCardBusinessSources = debitCardBusinessSource.map(
                item => {
                    return {
                        businessSourceNameUI: capitaliseString(item),
                        businessSourceValue: item,
                    };
                }
            );
        }

        if (emiBusinessSource && !isEmpty(emiBusinessSource)) {
            formatValues.emiBusinessSource = emiBusinessSource.map(item => {
                return {
                    businessSourceNameUI: capitaliseString(item),
                    businessSourceValue: item,
                };
            });
        }

        if (creditCardBusinessSource && !isEmpty(creditCardBusinessSource)) {
            formatValues.creditCardBusinessSources = creditCardBusinessSource.map(
                item => {
                    return {
                        businessSourceNameUI: capitaliseString(item),
                        businessSourceValue: item,
                    };
                }
            );
        }

        if (upiBusinessSource && !isEmpty(upiBusinessSource)) {
            formatValues.upiBusinessSources = upiBusinessSource.map(item => {
                return {
                    businessSourceNameUI: capitaliseString(item),
                    businessSourceValue: item,
                };
            });
        }

        if (upiAccountType && !isEmpty(upiAccountType)) {
            const resultObj = {};

            for (const [businessSource, accountTypes] of Object.entries(
                upiAccountType
            )) {
                const formattedAccountTypes = accountTypes.map(type => ({
                    accountTypesNameUI: capitalizeStringWithUnderscores(type),
                    accountTypesValue: type,
                }));

                resultObj[businessSource] = formattedAccountTypes;
            }

            formatValues.upiAccountTypes = !isEmpty(resultObj) ? resultObj : [];
        }

        if (upi && !isEmpty(upi)) {
            formatValues.upi = upi.map(item => {
                return {
                    ...item,
                    subModeNameUI: `${capitaliseString(item.subModeNameUI)}`,
                };
            });
        }

        if (creditCards && !isEmpty(creditCards)) {
            formatValues.creditCards = creditCards.map(item => {
                return {
                    ...item,
                    subModeNameUI:
                        (CARD_TYPE[item.subMode] &&
                            CARD_TYPE[item?.subMode]?.codeNameUI) ||
                        '-',
                };
            });
        }
        if (debitCards && !isEmpty(debitCards)) {
            formatValues.debitCards = debitCards.map(item => {
                return {
                    ...item,
                    subModeNameUI:
                        (CARD_TYPE[item.subMode] &&
                            CARD_TYPE[item.subMode].codeNameUI) ||
                        '-',
                };
            });
        }

        if (netbanking && !isEmpty(netbanking)) {
            formatValues.netbanking = netbanking.map(item => {
                return {
                    ...item,
                    subModeNameUI:
                        (BANK_CODE[item.subMode] &&
                            BANK_CODE[item.subMode].codeNameUI) ||
                        '-',
                };
            });
        }

        if (wallets && !isEmpty(wallets)) {
            formatValues.wallets = wallets.map(item => {
                return {
                    ...item,
                    subModeNameUI: item.subModeNameUI,
                    subMode: item.subMode,
                };
            });
        }

        if (accountVerification && !isEmpty(accountVerification)) {
            formatValues.accountVerification = accountVerification.map(item => {
                return {
                    ...item,
                    subModeNameUI: item.subModeNameUI,
                    subMode: item.subMode,
                };
            });
        }

        if (emi && !isEmpty(emi)) {
            formatValues.emi = emi.map(item => {
                return {
                    ...item,
                    subModeNameUI: item.subModeNameUI,
                    subMode: item.subMode,
                };
            });
        }
        return formatValues;
    }
    return payData;
};

const renderCustomSelect = props => {
    const { input, data, ...attributes } = props;
    const handleBlur = () => input.onBlur;
    return (
        <div className="custom-select-wrap">
            <CustomSelect
                instanceId={input.name}
                {...input}
                {...attributes}
                value={data}
                onBlur={handleBlur}
            />
        </div>
    );
};

renderCustomSelect.propTypes = {
    input: PropTypes.object,
    data: PropTypes.array,
};

const PayModeTab = ({
    merchantData,
    handleSubmit,
    history,
    nextPath,
    previousPath,
    auth,
    actions,
    sectionType,
    name,
    isEditMode,
    isViewMode,
    draftData,
    editData,
    change,
    onBoardSteps,
    isInEditMode,
    formData,
    dirty,
    staticData,
    allDraftData,
}) => {
    const {
        saveData,
        uniqueIdentifier: { uniqueId },
        paymentModes,
        timeline: { fields },
    } = merchantData;
    
    const { updateData, basicFormData = {} } = editData;
    const { location } = history;
    const memoizedPay = useMemo(
        () => getPayOptions(paymentModes, staticData.payValues),
        [paymentModes, staticData.payValues]
    );
    const dispatch = useDispatch();

    const {
        netbanking,
        creditCards,
        debitCards,
        upi,
        debitCardBusinessSources,
        creditCardBusinessSources,
        upiBusinessSources,
        upiAccountTypes,
        wallets,
        accountVerification,
        emiBusinessSource,
        emi,
    } = memoizedPay;


    const [selectedBanks, setSelectedBanks] = useState([]);
    const [bankOptions, setBankOptions] = useState([]);

    const [selectedWallets, setSelectedWallets] = useState([]);
    const [walletsOptions, setWalletsOptions] = useState([]);

    const [turnoverCategory, setTurnOverCategory] = useState("");

    const [isChange, setIsChange] = useState(false);
    const currentStep = first(
        onBoardSteps.filter(item => item.sectionType === sectionType)
    );

    // Determine if the user is in a terminal state based on the presence of 'nextPath'.
    const isUserTerminalState = !nextPath;

    const isRefIdEnabled = [
        {
            name: 'Enable Reference ID',
            value: 'isRefIdEnabled',
            checked: false,
        },
    ];

    useEffect(() => {
        let bankOptions = customOptions(netbanking, draftData, 'NB');
        if (Array.isArray(bankOptions)) {
            bankOptions = bankOptions.sort((cur, next) => {
                if (cur.label < next.label) {
                    return -1;
                }
                if (cur.label > next.label) {
                    return 1;
                }
                return 0;
            });
        }
        const checkedBanks =
            bankOptions && bankOptions.filter(item => item.checked);
        const filteredBanks =
            netbanking && netbanking.filter(item => item.subModeNameUI);
        const groupedOptions = [
            {
                label: '',
                options: allOption,
            },
            {
                label: 'Select Custom Bank ',
                options: bankOptions,
            },
        ];
        setBankOptions(groupedOptions);

        if (
            filteredBanks &&
            checkedBanks &&
            filteredBanks.length === checkedBanks.length
        ) {
            const allOpt = allOption;
            allOpt[0].checked = true;
            setSelectedBanks([...allOpt, ...checkedBanks]);
        } else {
            const banks = checkedBanks || [];
            setSelectedBanks(banks);
        }
    }, [draftData, netbanking]);

    useEffect(() => {
        let walletsOptions = customOptions(wallets, draftData, 'WALLET');
        if (Array.isArray(walletsOptions)) {
            walletsOptions = walletsOptions.sort((cur, next) => {
                if (cur.label < next.label) {
                    return -1;
                }
                if (cur.label > next.label) {
                    return 1;
                }
                return 0;
            });
        }
        const checkedWallets =
            walletsOptions && walletsOptions.filter(item => item.checked);
        const filteredWallets =
            wallets && wallets.filter(item => item.subModeNameUI);
        const groupedOptions = [
            {
                label: '',
                options: allOptionWallets,
            },
            {
                label: 'Select Custom Wallet ',
                options: walletsOptions,
            },
        ];
        setWalletsOptions(groupedOptions);

        if (
            filteredWallets &&
            checkedWallets &&
            filteredWallets.length === checkedWallets.length
        ) {
            const allOpt = allOptionWallets;
            allOpt[0].checked = true;
            setSelectedWallets([...allOpt, ...checkedWallets]);
        } else {
            const checkedWalletsList = checkedWallets || [];
            setSelectedWallets(checkedWalletsList);
        }
    }, [draftData, wallets]);

    const resetErrors = () => {
        if (isEditMode) {
            actions.resetUpdateDataSuccessKey();
        } else {
            actions.resetSaveDataSuccessKey();
        }
    };

    useEffect(() => {
        resetErrors();
       
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const history2 = useHistory();
    useEffect(() => {

        if (isEditMode || isViewMode) {
            const merchantId = last(location.pathname.split('/'));
            actions.getMerchantSectionInfoRequest(
                merchantId,
                fields,
                'paymentModeSection',
                history2
            );
        }
    }, [actions, fields, isEditMode, isViewMode, location.pathname, history2]);

    const onBack = () => {
        resetErrors();
        history.push(previousPath);
    };

    const onNext = () => {
        resetErrors();
        if (!isUserTerminalState) {
            history.push(nextPath);
        } else {
            history.push('/mob');
        }
    };

    const [isShowModal, setIsShowModal] = useState(false);

    const onSuccessModal = () => {
        setIsShowModal(false);
        if (formData && formData.values) {
            handleFormSubmit(formData.values);
        }
    };

    const onCloseModal = () => {
        setIsShowModal(false);
    };

    useEffect(() => {
        if (saveData.isSuccess && saveData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.SAVE_DATA(name));
            onNext();
        }
        return () => {
            if (saveData.isSuccess && saveData.sectionType === sectionType) {
                actions.resetSaveDataSuccessKey();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveData.isSuccess, saveData.sectionType]);

    useEffect(() => {
        if (updateData.isUpdated && updateData.sectionType === sectionType) {
            toast.info(SUCCESS_MESSAGES.UPDATE_MAKER_REQUEST_SUCCESS(name));
            onNext();
        }
        return () => {
            if (
                updateData.isUpdated &&
                updateData.sectionType === sectionType
            ) {
                actions.resetUpdateDataSuccessKey();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateData.isUpdated, updateData.sectionType]);

    useEffect(() => {
        change('netBanking', selectedBanks);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedBanks]);

    useEffect(() => {
        change('wallets', selectedWallets);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedWallets]);

    useEffect(() => {
        const portalValue = formData.values.isRefIdEnabled;
        if (portalValue === true || portalValue === 'isRefIdEnabled') {
            change('isRefIdEnabled', true);
        } else if (
            Array.isArray(portalValue) &&
            portalValue.includes('isRefIdEnabled')
        ) {
            change('isRefIdEnabled', true);
        } else {
            change('isRefIdEnabled', false);
        }
    }, [change, formData.values.isRefIdEnabled]);

    const getDynamicBoolValues = (values, key) => {
        console.log("values and key : ", values, key);
        const boolValues =
            values &&
            values[key] &&
            Array.isArray(values[key]) &&
            values[key].includes(key);
        return boolValues || false;
    };

    const handleFormSubmit = values => {
        if (
            REQUIRE(values.creditCard) &&
            REQUIRE(values.debitCard) &&
            REQUIRE(values.netBanking) &&
            REQUIRE(values.vpa) &&
            REQUIRE(values.wallets) &&
            REQUIRE(values.accountVerification) &&
            REQUIRE(values.emi)
        ) {
            toast.error('At least one of the payment combination needs to be checked in order to proceed further');
            return;
        }
        if (
            currentStep &&
            currentStep.dependentSections &&
            currentStep.dependentSections.length &&
            currentStep.status === 'Complete' &&
            isChange &&
            !isShowModal
        ) {
            setIsShowModal(true);
        } else {
            const selectedCreditCards = values.creditCard || [];
            const selectedDebitCards = values.debitCard || [];
            const selectedNetBanking = selectedBanks || [];
            const selectedUPIOptions = values.upi;
            const selectedMandateUpi = values.mandateUpi || [];
            const selectedWalletList = selectedWallets || [];
            const selectedAccountVerification =
                values.accountVerification || [];
            const selectedEMI = values.emi || [];

            if (
                values.upi &&
                values.upi.length > 0 &&
                values.upiBusinessSource &&
                values.upiBusinessSource.length <= 0
            ) {
                toast.error('Please select at least one UPI Business Source');
                return;
            }

            if (
                values.upi &&
                values.upi.length > 0 &&
                values.upiBusinessSource &&
                values.upiBusinessSource.length > 0
            ) {
                let isValidAccountType = true;
                let emptyBusinessSource = '';
                values.upiBusinessSource.forEach(
                    (businessSource, businessSourceIndex) => {
                        if (
                            !values[`upiAccountTypes-${businessSource}`] ||
                            values[`upiAccountTypes-${businessSource}`]
                                .length <= 0
                        ) {
                            isValidAccountType = false;
                            emptyBusinessSource = businessSource;
                        }
                    }
                );

                if (isValidAccountType === false) {
                    toast.error(
                        `Please select at least one account type for ${capitaliseString(
                            emptyBusinessSource
                        )} sources`
                    );
                    return;
                }
            }

            const creditCardOptions = creditCards
                .filter(mode => selectedCreditCards.includes(mode.subMode))
                .map(mode => ({
                    paymentType: mode.paymentType,
                    paymentModeInfo: mode.subMode,
                    txnConfig: values.creditCardBusinessSource?.map(
                        businessSource => {
                            return { businessSource };
                        }
                    ),
                }));

            // const upiOptions = upiEnabled
            //     ? [{ paymentType: 'UPI', paymentSubModeInfo: values.vpa }]
            //     : [];

            const upiOptions = upi
                ?.filter(mode => selectedUPIOptions?.includes(mode.subMode))
                ?.map(mode => ({
                    paymentType: mode.paymentType,
                    paymentModeInfo: mode.subMode,
                    paymentSubModeInfo: values.vpa,
                    txnConfig: values.upiBusinessSource?.map(businessSource => {
                        return {
                            businessSource,
                            accountType:
                                values[`upiAccountTypes-${businessSource}`],
                        };
                    }),
                }));

            const mandateUPIOptions = upi
                .filter(
                    mode =>
                        selectedMandateUpi.includes(mode.subMode) &&
                        selectedUPIOptions.includes(mode.subMode)
                )
                .map(mode => ({
                    paymentType: mode.paymentType,
                    paymentModeInfo: mode.subMode,
                    category: 'MANDATE',
                    
                    paymentSubModeInfo: values.vpa,
                    txnConfig: values.upiBusinessSource?.map(businessSource => {
                        return {
                            businessSource,
                            
                            accountType:
                                values[`upiAccountTypes-${businessSource}`],
                        };
                    }),
                }));
                

            const debitCardOptions = debitCards
                .filter(mode => selectedDebitCards.includes(mode.subMode))
                .map(mode => ({
                    paymentType: mode.paymentType,
                    paymentModeInfo: mode.subMode,
                    txnConfig: values.debitCardBusinessSource?.map(
                        businessSource => {
                            return { businessSource };
                        }
                    ),
                }));
            const netBankingOptions = selectedNetBanking
                .filter(item => item.value !== 'all')
                .map(item => {
                    return {
                        ...item.data,
                        txnConfig: [
                            {
                                businessSource: 'DOMESTIC',
                            },
                        ],
                    };
                });

            const walletsOptions = selectedWalletList
                .filter(item => item.value !== 'all')
                .map(item => item.data);

            const accountVerificationOptions = accountVerification
                .filter(mode =>
                    selectedAccountVerification.includes(mode.subMode)
                )
                .map(mode => ({
                    paymentType: mode.paymentType,
                    paymentModeInfo: mode.subMode,
                    paymentModeInfoUI: mode.subModeNameUI,
                }));

            const emiOptions = emi
                .filter(mode => selectedEMI.includes(mode.subMode))
                .map(mode => ({
                    paymentType: mode.paymentType,
                    paymentModeInfo: mode.subMode,
                    paymentModeInfoUI: mode.subModeNameUI,
                    txnConfig: values.emiBusinessSource?.map(businessSource => {
                        return { businessSource };
                    }),
                }));
            let ccSmallTxnFlaggedValue = false
            if(values?.[`upiAccountTypes-DOMESTIC`]?.includes("CC") && turnoverCategory == TURN_OVER_CATEGORIES["small"]){
                ccSmallTxnFlaggedValue = values["upiSmallTransaction"] || false;
            }
            
            const request = {
                uniqueIdentifier: uniqueId,
                sectionType,
                data: {
                    ccSmallTxnFlagged:ccSmallTxnFlaggedValue,
                    paymentLinkEnabled: getDynamicBoolValues(
                        values,
                        'paymentLinkEnabled'
                    ),
                    paymentPageEnabled: getDynamicBoolValues(
                        values,
                        'paymentPageEnabled'
                    ),
                    voidCapability: getDynamicBoolValues(
                        values,
                        'voidCapability'
                    ),
                    emiEnabled: getDynamicBoolValues(values, 'emiEnabled'),
                    isRefIdEnabled:
                        upiOptions.length > 0 ? values.isRefIdEnabled : false,
                    appId: values.appId,
                    paymentModeDetails: [
                        ...creditCardOptions,
                        ...debitCardOptions,
                        ...netBankingOptions,
                        ...walletsOptions,
                        ...upiOptions,
                        ...accountVerificationOptions,
                        ...emiOptions,
                        ...mandateUPIOptions,
                    ],
                },
            };

            if (isEditMode) {
                const merchantId = last(location.pathname.split('/'));
                const updateRequest = {
                    configurationType: 'PAYMENTMODE',
                    entityCode: merchantId || '',
                    
                    merchantConfig: {
                        paymentModeData: {
                            ccSmallTxnFlagged:ccSmallTxnFlaggedValue,
                            paymentLinkEnabled: getDynamicBoolValues(
                                values,
                                'paymentLinkEnabled'
                            ),
                            paymentPageEnabled: getDynamicBoolValues(
                                values,
                                'paymentPageEnabled'
                            ),
                            voidCapability: getDynamicBoolValues(
                                values,
                                'voidCapability'
                            ),
                            emiEnabled: getDynamicBoolValues(
                                values,
                                'emiEnabled'
                            ),
                            isRefIdEnabled:
                                upiOptions.length > 0
                                    ? values.isRefIdEnabled
                                    : false,
                            appId: values.appId,
                            paymentModeDetails: [
                                ...creditCardOptions,
                                ...debitCardOptions,
                                ...netBankingOptions,
                                ...upiOptions,
                                ...walletsOptions,
                                ...accountVerificationOptions,
                                ...emiOptions,
                                ...mandateUPIOptions,
                            ],
                        },
                    },
                };

                const makerDetails = {
                    makerId: auth.userDetails.email || '',
                    idempotencyId: merchantId,
                    eventType: MAKER_CHECKER_EVENT_TYPES.PAYMENTMODE,
                };

                actions.addMerchantStepUpdateMakerRequest(
                    updateRequest,
                    sectionType,
                    makerDetails
                );
            } else if (isViewMode) {
                onNext();
            } else {
                if (isUserTerminalState) {
                    actions.submitStepFormRequest(request, sectionType);
                } else {
                    actions.saveAndContinueRequest(request, sectionType);
                }
            }
        }
    };

    const getAllSelectedBanks = allBanks => {
        const bankList = allBanks[1];
        if (bankList) {
            return [...allOption, ...bankList.options];
        }
        return [];
    };

    const getAllSelectedWallets = allWallets => {
        const walletList = allWallets[1];
        if (walletList) {
            return [...allOptionWallets, ...walletList.options];
        }
        return [];
    };

    const checkIsAllRemoved = (oldState, newState) => {
        const isOldStateHaveAll = oldState.some(item => item.value === 'all');
        const isNewStateHaveAll = newState.some(item => item.value === 'all');
        return isOldStateHaveAll !== isNewStateHaveAll;
    };

    const isAllClicked = (oldState, newState) => {
        const isOldStateHaveAll = oldState.some(item => item.value === 'all');
        const isNewStateHaveAll = newState.some(item => item.value === 'all');
        return isOldStateHaveAll === false && isNewStateHaveAll === true;
    };

    const handleBankSelect = value => {
        setIsChange(true);
        const isAllRemoved = checkIsAllRemoved(selectedBanks, value);

        if (isAllClicked(selectedBanks, value)) {
            const allBanks = getAllSelectedBanks(bankOptions);
            setSelectedBanks(allBanks);
        } else if (isAllRemoved) {
            setSelectedBanks([]);
        } else {
            const selectedValue = value.filter(item => item.value !== 'all');
            if (selectedValue.length === bankOptions[1].options.length) {
                setSelectedBanks([...allOption, ...value]);
            } else {
                setSelectedBanks(selectedValue);
            }
        }
    };

    const handleWalletSelect = value => {
        setIsChange(true);
        const isAllRemoved = checkIsAllRemoved(selectedWallets, value);

        if (isAllClicked(selectedWallets, value)) {
            const allWallets = getAllSelectedWallets(walletsOptions);
            setSelectedWallets(allWallets);
        } else if (isAllRemoved) {
            setSelectedWallets([]);
        } else {
            const selectedValue = value.filter(item => item.value !== 'all');
            if (selectedValue.length === walletsOptions[1].options.length) {
                setSelectedWallets([...allOptionWallets, ...value]);
            } else {
                setSelectedWallets(selectedValue);
            }
        }
    };
    const errorDetails = isEditMode ? updateData : saveData;
    const isOrAre = currentStep.dependentSections.length > 1 ? 'are' : 'is';

    const getCheckboxOptions = (initialValuesData, data, keyField) => {
        if (initialValuesData && initialValuesData[keyField]) {
            return data.map(item => {
                if (initialValuesData[keyField]) {
                    return { ...item, checked: true };
                }
                return item;
            });
        }
        return data;
    };

    useEffect(() => {
        if (basicFormData?.upiDetails) {
            const merchentVPA = basicFormData.upiDetails.merchantVpa;
            const isRefIdEnabled = basicFormData.upiDetails.isRefIdEnabled;
            dispatch(changeValue('payMode-form', 'vpa', merchentVPA));
            dispatch(changeValue('payMode-form', 'isRefIdEnabled', isRefIdEnabled));
        }
    }, [basicFormData, dispatch, formData.initial])

    useEffect(() => {
        if (isEditMode || isViewMode) {
            const merchantId = last(location.pathname.split('/'));
            let req = {
                entityCode: merchantId,
                sectionType,
            };
            actions.fetchBasicFormData(req);
        }
    }, [isEditMode, isViewMode, actions])

    useEffect(() => {
        if (isEditMode || isViewMode) {
            const merchantId = last(location.pathname.split('/'));
            actions.getMerchantInfoRequest(merchantId, fields, history,toast);
        }
    }, [actions, fields, isEditMode, isViewMode, location.pathname]);

    useEffect(() => {
        let sections = [];

        if ((isEditMode || isViewMode)) {
            if(editData){
                sections = editData.sections;
            }
        } else {
            sections = allDraftData;
        }
        
        const merchantSection = sections.find(item => item.type === "createMerchantSection");
         const paymentSectionData = sections.find(item=>item.type === "paymentModeSection");
        if(paymentSectionData){
            const ccSmallTransaction = paymentSectionData?.data?.ccSmallTxnFlagged || false
            dispatch(changeValue('payMode-form', 'upiSmallTransaction', ccSmallTransaction));
        }
        if (merchantSection) {
            const integrationType = merchantSection.data?.integrationType;
            change('integrationType', integrationType);
            const turnoverCategoryData = merchantSection?.data?.turnoverCategory
            
            setTurnOverCategory(turnoverCategoryData)
            
        }
    }, [editData, change, allDraftData, isEditMode, isViewMode]);

    useEffect(() => {
        if(formData.initial && change){
            const preVpa = formData.initial.vpa;
            change('preVpa', preVpa);
        }
    }, [formData.initial, change]);

    return (
        <form
            className="payMode-list-form"
            onSubmit={handleSubmit(handleFormSubmit)}
        >
            <div className="payMode-tab card">
                <h2 className="tab-title">Payment Mode</h2>
                {errorDetails.error && errorDetails.error.errorMessage ? (
                    <Alert customClass="error-msg">
                        {errorDetails.error.errorMessage}
                    </Alert>
                ) : null}
                {paymentModes.error && paymentModes.error.errorMessage ? (
                    <Alert customClass="error-msg">
                        {paymentModes.error.errorMessage}
                    </Alert>
                ) : null}
                <AlertModal
                    modalIsOpen={isShowModal}
                    closeModal={onCloseModal}
                    primaryButtonText="OK"
                    secondaryButtonText="CANCEL"
                    showActions={true}
                    onSuccessModal={onSuccessModal}
                    currentSection={currentStep}
                    message={`${getDependentSectionName(
                        onBoardSteps,
                        currentStep.dependentSections
                    )}
                    ${isOrAre} dependent on ${currentStep.name}
                    section. Please update dependent sections.`}
                />
                <ul className="form-list">
                    <li className="form-section debit-section">
                        <div className="form-field">
                            <p className="label">Debit Card</p>
                            <Field
                                name="debitCard"
                                id="debit-card"
                                component={FormElems.Checkbox}
                                labelField="subModeNameUI"
                                valueField="subMode"
                                options={debitCards}
                                isDisabled={isViewMode}
                                handleChange={() => {
                                    setIsChange(true);
                                }}
                            />
                        </div>
                    </li>
                    {formData &&
                        formData.values.debitCard &&
                        formData.values.debitCard.length > 0 && (
                            <li className="form-section debit-section">
                                <div className="form-field">
                                    <p className="label">
                                        Debit Card Business Source
                                    </p>
                                    <Field
                                        name="debitCardBusinessSource"
                                        id="debit-card-business-source"
                                        component={FormElems.Checkbox}
                                        labelField="businessSourceNameUI"
                                        valueField="businessSourceValue"
                                        options={debitCardBusinessSources}
                                        isDisabled={isViewMode}
                                        handleChange={() => {
                                            setIsChange(true);
                                        }}
                                    />
                                </div>
                            </li>
                        )}
                </ul>
                <ul className="form-list">
                    <li className="form-section credit-section">
                        <div className="form-field">
                            <p className="label">Credit Card</p>
                            <Field
                                name="creditCard"
                                id="credit-card"
                                component={FormElems.Checkbox}
                                labelField="subModeNameUI"
                                valueField="subMode"
                                options={creditCards}
                                isDisabled={isViewMode}
                                handleChange={() => {
                                    setIsChange(true);
                                }}
                            />
                        </div>
                    </li>
                    {formData &&
                        formData.values.creditCard &&
                        formData.values.creditCard.length > 0 && (
                            <li className="form-section credit-section">
                                <div className="form-field">
                                    <p className="label">
                                        Credit Card Business Source
                                    </p>
                                    <Field
                                        name="creditCardBusinessSource"
                                        id="credit-card-business-sources"
                                        component={FormElems.Checkbox}
                                        labelField="businessSourceNameUI"
                                        valueField="businessSourceValue"
                                        options={creditCardBusinessSources}
                                        isDisabled={isViewMode}
                                        handleChange={() => {
                                            setIsChange(true);
                                        }}
                                    />
                                </div>
                            </li>
                        )}
                </ul>

                <ul className="form-list">
                    <li className="form-section upi-section">
                        <div className="form-field other-section">
                            <p className="label">UPI</p>
                            <Field
                                name="upi"
                                id="upi"
                                component={FormElems.Checkbox}
                                labelField="subModeNameUI"
                                valueField="subMode"
                                options={upi}
                                isDisabled={isViewMode}
                                handleChange={() => {
                                    setIsChange(true);
                                }}
                            />
                        </div>
                    </li>

                    {formData &&
                        Array.isArray(formData.values.upi) &&
                        formData.values.upi.length > 0 &&
                        formData.values.upi.some(
                            mode => mode !== 'SDK' && mode !== 'STATIC_QR'
                        ) && (
                            <li className="form-section upi-section">
                                <div className="form-field other-section">
                                    <p className="label">UPI Mandate Mode</p>
                                    <Field
                                        name="mandateUpi"
                                        id="mandate-upi"
                                        component={FormElems.Checkbox}
                                        labelField="subModeNameUI"
                                        valueField="subMode"
                                        options={upi?.filter(
                                            upiMode =>
                                                formData.values.upi.includes(upiMode.subMode) &&
                                                upiMode.subMode !== 'SDK' &&  upiMode.subMode !== 'STATIC_QR'
                                        )}
                                        isDisabled={isViewMode}
                                        handleChange={event => {
                                            setIsChange(true);
                                        }}
                                    />
                                </div>
                            </li>
                        )}




                    {formData &&
                        formData.values.upi &&
                        formData.values.upi.length > 0 && (
                            <li className="form-section upi-section">
                                <div className="form-field other-section">
                                    <p className="label">UPI Business Source</p>
                                    <Field
                                        name="upiBusinessSource"
                                        id="upi-business-sources"
                                        component={FormElems.Checkbox}
                                        labelField="businessSourceNameUI"
                                        valueField="businessSourceValue"
                                        options={upiBusinessSources}
                                        isDisabled={isViewMode}
                                        handleChange={event => {
                                            setIsChange(true);
                                        }}
                                    />
                                </div>
                            </li>
                        )}

                    {formData &&
                        formData.values &&
                        formData.values.upi &&
                        formData.values.upi.length > 0 &&
                        formData.values.upiBusinessSource &&
                        formData.values.upiBusinessSource.length > 0 &&
                        <>
                        {formData.values.upiBusinessSource.map(
                                businessSource => (
                                    <li className="form-section credit-section">
                                        <div className="form-field other-section">
                                            <p className="label">
                                                {capitalizeStringWithUnderscores(
                                                    businessSource
                                                )}{' '}
                                                Account Types
                                            </p>
                                            <Field
                                                name={`upiAccountTypes-${businessSource}`}
                                                id={`upi-account-types-${businessSource}`}
                                                component={FormElems.Checkbox}
                                                labelField="accountTypesNameUI"
                                                valueField="accountTypesValue"
                                                options={
                                                    upiAccountTypes[businessSource]
                                                }
                                                isDisabled={isViewMode}
                                                handleChange={() => {
                                                    setIsChange(true);
                                                }}
                                            />
                                        </div>
                                    </li>
                                )
                            )}
                        {formData.values?.[`upiAccountTypes-DOMESTIC`]?.includes("CC") && turnoverCategory == TURN_OVER_CATEGORIES["small"] && <RenderFieldList 
                            label={`CC Small Transaction`}
                            fieldName={`upiSmallTransaction`}
                            id={`upi-small-transaction`}
                            fieldType={`Switch`}
                            
                        />}
                        </>
                        }
                </ul>
                        
                <ul className="form-list">
                    {formData &&
                        formData.values.upi &&
                        formData.values.upi.length > 0 && (
                            <li className="form-section upi-form">
                                <div className="form-field">
                                    <p className="label">UPI VPA</p>
                                    <Field
                                        name="vpa"
                                        type="text"
                                        id="vpa"
                                        component={FormElems.Input}
                                        placeholder="Enter VPA"
                                        disabled={isViewMode}
                                    />
                                    <div className="upi-ref-id">
                                        <Field
                                            name="isRefIdEnabled"
                                            component={FormElems.Checkbox}
                                            labelField="name"
                                            wrapperClass="wrap-checkbox"
                                            options={getCheckboxOptions(
                                                formData.values,
                                                isRefIdEnabled,
                                                'isRefIdEnabled'
                                            )}
                                            valueField="value"
                                            isDisabled={isViewMode}
                                        />
                                    </div>
                                </div>
                                {formData.values.upi.includes('SDK') ? (
                                    <div className="form-field">
                                        <p className="label">App ID</p>
                                        <Field
                                            name="appId"
                                            type="text"
                                            id="appId"
                                            component={FormElems.Input}
                                            placeholder="Enter App ID"
                                            disabled={isViewMode}
                                        />
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </li>
                        )}
                </ul>

                <ul className="form-list">
                    <li className="form-section ">
                        <div className="form-field">
                            <p className="label">Account Verification</p>
                            <Field
                                name="accountVerification"
                                id="account-verification"
                                component={FormElems.Checkbox}
                                labelField="subModeNameUI"
                                valueField="subMode"
                                options={accountVerification}
                                isDisabled={isViewMode}
                                handleChange={() => {
                                    setIsChange(true);
                                }}
                            />
                        </div>
                    </li>
                </ul>

                <ul className="form-list">
                    <li className="form-section debit-section">
                        <div className="form-field">
                            <p className="label">EMI</p>
                            <Field
                                name="emi"
                                id="emi"
                                component={FormElems.Checkbox}
                                labelField="subModeNameUI"
                                valueField="subMode"
                                options={emi}
                                isDisabled={isViewMode}
                                handleChange={() => {
                                    setIsChange(true);
                                }}
                            />
                        </div>
                    </li>
                    {formData &&
                        formData.values.emi &&
                        formData.values.emi.length > 0 && (
                            <li className="form-section debit-section">
                                <div className="form-field">
                                    <p className="label">EMI Business Source</p>
                                    <Field
                                        name="emiBusinessSource"
                                        id="emi-business-source"
                                        component={FormElems.Checkbox}
                                        labelField="businessSourceNameUI"
                                        valueField="businessSourceValue"
                                        options={emiBusinessSource}
                                        isDisabled={isViewMode}
                                        handleChange={() => {
                                            setIsChange(true);
                                        }}
                                    />
                                </div>
                            </li>
                        )}
                </ul>

                <ul className="form-list">
                    <li>
                        <div className="form-field other-section">
                            <p className="label">Other Payment Modes</p>
                            <Field
                                name="paymentLinkEnabled"
                                id="payment-link"
                                component={FormElems.Checkbox}
                                options={[
                                    {
                                        label: 'Payment Link',
                                        value: 'paymentLinkEnabled',
                                    },
                                ]}
                                labelField="label"
                                valueField="value"
                                isDisabled={isViewMode}
                            />
                            <Field
                                name="paymentPageEnabled"
                                id="form-builder"
                                component={FormElems.Checkbox}
                                options={[
                                    {
                                        label: 'Payment Page',
                                        value: 'paymentPageEnabled',
                                    },
                                ]}
                                labelField="label"
                                valueField="value"
                                isDisabled={isViewMode}
                            />
                            <Field
                                name="voidCapability"
                                id="void-capability"
                                component={FormElems.Checkbox}
                                options={[
                                    {
                                        label: 'Void Transactions',
                                        value: 'voidCapability',
                                    },
                                ]}
                                labelField="label"
                                valueField="value"
                                isDisabled={isViewMode}
                            />
                            {/* <Field
                                name="emiEnabled"
                                id="emi-pay"
                                component={FormElems.Checkbox}
                                options={[
                                    {
                                        label: 'EMI',
                                        value: 'emiEnabled',
                                    },
                                ]}
                                labelField="label"
                                valueField="value"
                                isDisabled={isViewMode}
                            /> */}
                        </div>
                    </li>
                </ul>
                <ul className="form-list">
                    <li className="form-section netbanking-sec">
                        <div className="form-field nb-payMode">
                            <p className="label">Net banking </p>
                            <Field
                                name="netBanking"
                                id="net-banking"
                                customClass="paymode-select"
                                options={bankOptions}
                                components={{ Option, ValueContainer }}
                                isMulti
                                isSearchable
                                data={selectedBanks}
                                onChange={handleBankSelect}
                                closeMenuOnSelect={false}
                                component={renderCustomSelect}
                                placeholder="Select Bank"
                                isDisabled={isViewMode}
                                formatGroupLabel={formatGroupLabel}
                            />
                        </div>
                    </li>

                    <li className="form-section">
                        <div className="form-field nb-payMode">
                            <p className="label">Wallets</p>
                            <Field
                                name="wallets"
                                id="wallets"
                                customClass="paymode-select"
                                options={walletsOptions}
                                components={{ Option, ValueContainer }}
                                isMulti
                                isSearchable
                                data={selectedWallets}
                                onChange={handleWalletSelect}
                                closeMenuOnSelect={false}
                                component={renderCustomSelect}
                                placeholder="Select Wallets"
                                isDisabled={isViewMode}
                                formatGroupLabel={formatGroupLabel}
                            />
                        </div>
                    </li>
                </ul>
            </div>
             <div className="form-section action">
                {!isViewMode &&(
                    <>
                    {previousPath ? (
                        <FormElems.Button
                            buttonType="secondary"
                            id="back-btn"
                            text="BACK"
                            type="button"
                            handleClick={onBack}
                            customClass="back-btn"
                        />
                    ) : null}
                    <FormElems.Button
                        id="next-btn"
                        buttonType="primary"
                        text="NEXT"
                    />
                </>
            )}
            </div>
        </form>
    );
};

PayModeTab.propTypes = {
    merchantData: PropTypes.object,
    handleSubmit: PropTypes.func,
    history: PropTypes.object,
    nextPath: PropTypes.string,
    previousPath: PropTypes.string,
    name: PropTypes.string,
    sectionType: PropTypes.string,
    auth: PropTypes.object,
    actions: PropTypes.object,
    draftData: PropTypes.object,
    isEditMode: PropTypes.bool,
    editData: PropTypes.object,
    change: PropTypes.func,
    isViewMode: PropTypes.bool,
    onBoardSteps: PropTypes.array,
    isInEditMode: PropTypes.bool,
    formData: PropTypes.object,
    staticData: PropTypes.object,
    initialValues: PropTypes.object,
    dirty: PropTypes.bool,
};

Option.propTypes = {
    data: PropTypes.object.isRequired,
    isSelected: PropTypes.bool,
};

ValueContainer.propTypes = {
    hasValue: PropTypes.bool,
    children: PropTypes.array,
    getValue: PropTypes.func,
};

const mapStateToProps = ({
    auth,
    form,
    merchantData,
    editData,
    staticData,
}) => ({
    auth,
    formData: form['payMode-form'],
    merchantData,
    editData,
    staticData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            hideLoader,
            showLoader,
            saveAndContinueRequest,
            resetSaveDataSuccessKey,
            updateSectionDataRequest,
            addMerchantStepUpdateMakerRequest,
            resetUpdateDataSuccessKey,
            getMerchantSectionInfoRequest,
            submitStepFormRequest,
            fetchBasicFormData,
            getMerchantInfoRequest,
        },
        dispatch
    ),
});

export default withRouter(
    compose(
        reduxForm({
            form: 'payMode-form',
            enableReinitialize: true,
            validate,
        }),
        connect(mapStateToProps, mapDispatchToProps)
    )(PayModeTab)
);
